import { SeriesPoint } from '../../core/models/domain.models';

export interface NamedSeries {
  name: string;
  series: SeriesPoint[];
  /** Dashed line, no area fill — used for forecast/projected continuations. */
  projected?: boolean;
}

export function palette(dark: boolean): string[] {
  return dark
    ? ['#3FB8AE', '#7FA6E8', '#E2A33C', '#D67BA8', '#8AC77B', '#A08BE0']
    : ['#0F8B84', '#3D6BC6', '#C98A1B', '#B85586', '#5B9E4D', '#7C63C9'];
}

export function baseText(dark: boolean) {
  return {
    ink: dark ? '#E9EEF3' : '#16202B',
    muted: dark ? '#93A1B0' : '#5D6B7A',
    line: dark ? '#2A3541' : '#DDE3E9',
    surface: dark ? '#171E26' : '#FFFFFF',
  };
}
